import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap/all';
import { Text, Container, Image } from '@weareconceptstudio/core';

//* Styles
import HeroAboutStyle from './style';

//* Animation
import { animationTitle } from '@/helpers/_animationTitle';

//* Component

const HeroAbout = ({ mobileImage, desktopImage, title, description }) => {
	//! State
	const [isLoading, setIsLoading] = useState(false);
	const [getPercent, setGetPercent] = useState(true);

	//! Ref
	const refSplitText = useRef();
	const titleRef = useRef();

	useEffect(() => {
		if (isLoading) {
			gsap.to('.wrapper-image', {
				scale: 1,
				duration: 0.7,
				ease: 'power2.out',
			});
			animationTitle({
				element: titleRef.current,
				ref: refSplitText,
				duration: 0.7,
				delay: 0.1,
				percentFunction: setGetPercent,
				percent: 50,
			});
			if (getPercent) {
				gsap.to('.description', {
					x: 0,
					y: 0,
					duration: 0.7,
					delay: getPercent,
					ease: 'power2.out',
				});
			}
		}
		return () => {
			refSplitText.current?.revert();
		};
	}, [isLoading, getPercent]);

	return (
		<HeroAboutStyle>
			<div className='wrapper-title-description'>
				<div className={'info-wrapper'}>
					<Container row>
						<div className='col-6 col-t-7 col-m-12 inner-wrapper'>
							<Text
								ref={titleRef}
								className={'uppercase h1 opacity-zero'}
								tag={'h1'}>
								{title}
							</Text>
							<Text className='p2 description'>{description}</Text>
						</div>
					</Container>
				</div>
			</div>
			<div className='wrapper-image'>
				<Image
					onLoad={setIsLoading}
					double={[desktopImage, mobileImage]}
				/>
			</div>
		</HeroAboutStyle>
	);
};

export default HeroAbout;
